module.exports = __webpack_public_path__ + "778b36adcb73abcca9c6e92e85f1b99a.svg";